import { Card as MuiCard, CardProps } from "@mui/material";

export const Card = (props: CardProps) => {
  const { sx, ...rest } = props;
  return (
    <MuiCard
      {...rest}
      sx={{
        ...sx,
        transition: "border 0.2s ease-in-out",
        "& .MuiCardMedia-root": {
          transition: "opacity 0.2s ease-in-out",
        },
        "&:hover": {
          border: "1px solid",
          borderColor: "divider",
          "& .MuiCardMedia-root": {
            opacity: 0.5,
          },
        },
      }}
    />
  );
};
